module.exports = __webpack_public_path__ + "img/document-apply.14c3c497.svg";